module.exports = __webpack_public_path__ + "static/screen5-aa7d1973be8d4589710c901f270a30e4.png";